import { z } from 'zod';

export const TenantPatchBody = z.object({
  displayName: z.string().trim().min(1).optional(),
  tileServerUrl: z.url().optional(),
  cloudRetentionDays: z.number().int().min(1).max(999).optional(),
});

export type TenantPatchBodyType = z.infer<typeof TenantPatchBody>;
